









/* Created- 24 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
@Component(
	{
		name: "ParticaCardXl"
	})
export default class ParticaCardXl extends Vue {
	@Prop() private title: string; // your data

	private getWidth() {
		// @ts-ignore
		if (this.$vuetify.breakpoint.smAndDown) {
			return "98%";
		} else {
			return 1000;
		}
	}
}
